import styled from 'styled-components'

const Container = styled.div.attrs({ className: 'container' })``

export default Container



// WEBPACK FOOTER //
// ./src/components/templates/app/Container.js